import { useEffect, useState } from 'react';

export const useInitialSectionVisibility = PD_profileComplete => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        return setOpen(!Boolean(PD_profileComplete));
    }, [PD_profileComplete]);

    return [open, setOpen];
};
